// extracted by mini-css-extract-plugin
export default {"confirmation-container":"confirmation_confirmation-container__VLXvw","confirmation-button":"confirmation_confirmation-button__GcjGe","ui-button":"confirmation_ui-button__BSq-O"};